module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/icon_orange-e628f6f58f6aa68771bf1254a3ba8a33.png";